import getApi from '../../api'
import { TagMutationPayload, TagType } from '../../model/Tag'

export const updateTag = (id: string, tag: TagMutationPayload) =>
  getApi().put<TagType>(`/tags/${id}`, tag)
